module.exports = __webpack_public_path__ + "img/101010.59f610cf.png";